import React, {Component} from 'react';
import CAUIWrapper from '../common/CommonAuthUserInterfaceWrapper';
import './WebLogin.scss';
import queryString from 'query-string';
import jwt_decode from "jwt-decode";
import Cookies from 'js-cookie';

class WebLogin extends Component {
  constructor(props) {
    super(props);
    this.queryParams = queryString.parse(document.location.search);
    this.state = {
      requestToken: Cookies.get('RequestToken'),
      authRequestId: this.getDecodedRequestId(),
      applianceUrl: null,
      timeoutId: null,
      loadCaui: false
    };
  }

  componentDidMount = () => {
    window.addEventListener('loadCaui', this.loadCaui);
    // showCaui is variable from agent_login.js
    // used to show caui in case component is mounted with delay and missed loadCaui event
    if (showCaui) {
      this.setState({
        loadCaui: true
      });
    }
  }

  componentWillUnmount = () => {
    window.removeEventListener('loadCaui', this.loadCaui);
  }

  loadCaui = (e) => {
    this.setState({
      loadCaui: e.detail.loadCaui
    });
  }

  getDecodedRequestId = () => {
    const jwtToken = Cookies.get('RequestToken');
    if (jwtToken) {
      const decodedToken = jwt_decode(jwtToken);
      if (decodedToken != null) {
        return decodedToken.requestId;
      }
    }
    return '';
  }

  handleApplianceUrlChange = (event) => {
    event.persist();
    // eslint-disable-next-line no-undef
    hideCaui();
    let timeout = setTimeout(function () {
      console.log("Waited for IMDA response for 10 seconds.");
      // eslint-disable-next-line no-undef
      displayCaui();
    }, 10000);
    this.setState(() => (
      {
        applianceUrl: event.target.value,
        timeoutId: timeout
      }
    ));
  }

  corsAuthRequestToAppliance = async () => {
    console.log("CAUI WRAPPER: Starting IMDA authentication flow. Requesting token from: " + this.state.applianceUrl);
    if (this.state.timeoutId) {
      clearTimeout(this.state.timeoutId);
    }
    // eslint-disable-next-line no-undef
    hideCaui();
    if (this.state.authRequestId == null || this.state.authRequestId === ''
      || this.state.applianceUrl == null || this.state.applianceUrl === '') {
      console.log('Request Id or Appliance URL is missing');
      // eslint-disable-next-line no-undef
      displayCaui();
      return;
    }
    await fetch(this.state.applianceUrl + '/sso/rest/v1/seamless_auth', {
      mode: 'cors',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        authRequestId: this.state.authRequestId
      })
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Seamless Auth response was not ok');
        } return response;
      })
      .then(response => response.json())
      .then(json => {
        console.log("CAUI WRAPPER: IMDA authentication flow - received auth token from appliance");
        var agent = document.getElementById("agent");
        if (agent) {
          agent.value = "IMDA";
        }
        if(json.authToken){
          console.log("CAUI WRAPPER: IMDA authentication flow - completed and submitting token to IdP");
          this.sendSuccessResponse(json.authToken);
        } else {
          //Handle server error response
          //{"code":"Failed"}
          // eslint-disable-next-line no-undef
          displayCaui();
          console.error(
              'There has been a problem with fetch operation:',
              json.code
          );
        }
      })
      .catch(error => {
        // eslint-disable-next-line no-undef
        displayCaui();
        console.error(
          'There has been a problem with fetch operation:',
          error
        );
      });
  }

  sendSuccessResponse = token => {
    let authTokenElement = document.getElementById('auth_token');
    authTokenElement.value = token;
    let authRequestIdElement = document.getElementById('auth_request_id');
    authRequestIdElement.value = this.state.authRequestId;
    let authForm = document.getElementById('auth_form');
    authForm.submit();
  }

  sendWsFedResult = (wa, wctx, wresult, url) => {
    let waElement = document.getElementById('wa');
    waElement.value = wa;
    let wctxElement = document.getElementById('wctx');
    wctxElement.value = wctx;
    let wresultElement = document.getElementById('wresult');
    wresultElement.value = wresult;
    let wsFedForm = document.getElementById('ws_fed_form');
    wsFedForm.setAttribute('action', url);
    wsFedForm.submit();
  }

  //TODO: temporary stubs left as a params values for dev testing
  render() {
    const {
      token, cloudEnv, ssdmEnv, username, appName, partnerName,
      transactionId, audience, deviceModel, deviceName, responseDomain, forceAuthn,
      resumeAuthFlowTokenUrl, forceMfa, errorHandler, applicationName, jti,
    } = this.queryParams;
    const knownHosts = [
      'idpuser-client.dev.common.imprivata.com',
      'idpuser-client.integration.common.imprivata.com',
      'idpuser-client.staging.common.imprivata.com',
      'idpuser-client.cloud.imprivata.com',
    ];
    const domainSuffix = knownHosts.includes(window.location.hostname)
      ? window.location.hostname.replace('idpuser-client', '')
      : '.dev.common.imprivata.com';
    const isAndroidUserAgent = navigator.userAgent.match("Android");

    // We temporarily update the token with the applicationName for customization Parkland
    var updatedToken;
    const updateTokenWithCustomData = () => {
      var decodedToken = JSON.parse(atob(token));
      var useCustomUX = (
        // production env
        decodedToken.tenantId === '6726383404517217470' ||
        // test env
        decodedToken.tenantId === '1050344203156845834' ||
        // special appName for QE
        applicationName === 'P@rkl3ndKycTomUX1'
      )
      updatedToken = btoa(JSON.stringify({ ...decodedToken, useCustomUX }));
    }
    token ? updateTokenWithCustomData() : {};

    return (
      <div className="app">
        { this.state.loadCaui ?
          <div className="imprivata-remote-access-screen">
            <CAUIWrapper
              contextDataToken={token ? updatedToken : 'testToken'}
              jti={jti}
              cloudEnv={cloudEnv ? cloudEnv : 'applex' + domainSuffix}
              ssdmEnv={ssdmEnv ? ssdmEnv : 'ssdm' + domainSuffix}
              product={'WebLogin'}
              onAuthTokenReceived={this.sendSuccessResponse}
              onWsFedResultReceived={this.sendWsFedResult}
              usernameInput={username}
              resumeAuthFlowTokenUrlInput={resumeAuthFlowTokenUrl ? 'https://' + responseDomain + '.imprivata.com/' + resumeAuthFlowTokenUrl : null}
              errorHandlerUrlInput={errorHandler ? 'https://' + responseDomain + '.imprivata.com/' + errorHandler : null}
              forceMfaInput={(String(forceMfa).toLowerCase() === 'true')}
              cidMobileServiceInfo={
                {
                  optionalPartnerName: partnerName,
                  optionalAppName: appName,
                  optionalTransactionId: transactionId,
                  optionalAudience: audience,
                  optionalDeviceInfo: {
                    optionalDeviceModel: deviceModel,
                    optionalDeviceName: deviceName
                  },
                  optionalCapabilities: null
                }
              }
            />
          </div> : null
        }
        {isAndroidUserAgent && forceAuthn !== "true" ?
          <div className='visually-hidden'>
            <span id='impr_request_token'>{this.state.requestToken}</span>
            <input id='impr_appliance_url' type='text' onChange={this.handleApplianceUrlChange}/>
            <button id='impr_seamless_auth' onClick={this.corsAuthRequestToAppliance}/>
          </div>
          : null}
      </div>
    )
  }
}

export default WebLogin;
